import React from 'react';
import { Box, Typography } from '@mui/material';

const elements = new Set(['p', 'br', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'blockquote', 'a', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'sup', 'sub']);
const discarded = new Set(['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'form', 'input', 'button']);

// Render the saved rich-text structure without executing model HTML or loading media.
function richNodes(nodes, prefix = 'preview') {
  return Array.from(nodes).map((node, index) => {
    const key = `${prefix}-${index}`;
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1) return null;
    const name = node.tagName.toLowerCase();
    if (discarded.has(name)) return null;
    const children = richNodes(node.childNodes, key);
    if (!elements.has(name)) return <React.Fragment key={key}>{children}</React.Fragment>;
    const props = { key };
    if (name === 'a') {
      const href = node.getAttribute('href') || '';
      if (/^https?:\/\//i.test(href)) Object.assign(props, { href, target: '_blank', rel: 'noopener noreferrer' });
    }
    if (name === 'br') return React.createElement(name, props);
    return React.createElement(name, props, children);
  });
}

export default function SeoContentPreview({ value, html = false, language, maxHeight = 360, empty = 'Empty' }) {
  if (!String(value || '').trim()) return <Typography variant="body2" color="text.secondary">{empty}</Typography>;
  let content = value;
  if (html) { const template = document.createElement('template'); template.innerHTML = String(value); content = richNodes(template.content.childNodes); }
  return <Box dir={language === 'sa' ? 'rtl' : 'auto'} sx={{ fontSize: '.875rem', lineHeight: 1.7, whiteSpace: html ? 'normal' : 'pre-wrap', overflowWrap: 'anywhere', maxHeight, overflow: 'auto', '& p:first-of-type': { mt: 0 }, '& h2, & h3, & h4': { lineHeight: 1.4 }, '& table': { width: '100%', borderCollapse: 'collapse' }, '& th, & td': { border: '1px solid', borderColor: 'divider', p: .75 }, '& a': { color: 'primary.main' }, '& ul, & ol': { pl: 3 } }}>{content}</Box>;
}
